import React from 'react'
import Container from '@mui/material/Container'
import { CircularProgress, Typography } from '@mui/material'
import { Slide, Fade } from 'react-awesome-reveal'
import ProjectGrid from './ProjectGrid'
import { useConfig } from '../../hooks/useConfig'

const Projects: React.FC = () => {
    const { config, loading } = useConfig()

    if (loading || !config) {
        return (
            <Container
                sx={{
                    width: '100%',
                    paddingBottom: '20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '50vh',
                }}
            >
                <CircularProgress />
            </Container>
        )
    }

    return (
        <Container
            sx={{
                width: '100%',
                paddingBottom: '20px',
                py: 8,
                minHeight: '100vh',
            }}
        >
            <Fade triggerOnce>
                <Slide direction="down" triggerOnce>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            fontSize: { xs: '2rem', md: '3rem' },
                            fontWeight: 700,
                            mb: 6,
                            textAlign: 'center',
                            color: 'primary.main',
                        }}
                    >
                        {config.projects.title}
                    </Typography>
                </Slide>
            </Fade>

            <Fade delay={200} triggerOnce>
                <ProjectGrid />
            </Fade>
        </Container>
    )
}

export default Projects
